import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from '../components/sellwithus/HeroSection';
import ProcessSection from '../components/sellwithus/ProcessSection';
import BenefitsSection from '../components/sellwithus/BenefitsSection';
import MarketingStrategySection from '../components/sellwithus/MarketingStrategySection';
import TestimonialSection from '../components/sellwithus/TestimonialSection';
import FAQSection from '../components/sellwithus/FAQSection';
import CTASection from '../components/sellwithus/CTASection';

const SellWithUs = () => {
  return (
    <div className="bg-white">
      <Helmet>
        <title>Vendi con Noi | Valutazione Gratuita | Molinaro Immobiliare</title>
        <meta name="description" content="Affida a Molinaro Immobiliare la vendita del tuo immobile a Scandicci. Valutazione gratuita, marketing efficace e vendita al miglior prezzo in tempi rapidi." />
        <meta name="keywords" content="vendere casa Scandicci, valutazione immobiliare gratuita, agenzia immobiliare Scandicci, vendita immobiliare, consulenza vendita casa" />
        <link rel="canonical" href="https://www.molinaroimmobiliare.it/vendi-con-noi" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.molinaroimmobiliare.it/vendi-con-noi" />
        <meta property="og:title" content="Vendi con Noi | Valutazione Gratuita | Molinaro Immobiliare" />
        <meta property="og:description" content="Affida a Molinaro Immobiliare la vendita del tuo immobile a Scandicci. Valutazione gratuita, marketing efficace e vendita al miglior prezzo in tempi rapidi." />
        <meta property="og:image" content="https://www.molinaroimmobiliare.it/images/agenzia5.jpeg" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.molinaroimmobiliare.it/vendi-con-noi" />
        <meta property="twitter:title" content="Vendi con Noi | Valutazione Gratuita | Molinaro Immobiliare" />
        <meta property="twitter:description" content="Affida a Molinaro Immobiliare la vendita del tuo immobile a Scandicci. Valutazione gratuita, marketing efficace e vendita al miglior prezzo in tempi rapidi." />
        <meta property="twitter:image" content="https://www.molinaroimmobiliare.it/images/agenzia5.jpeg" />
        
        {/* Structured Data for Service */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Servizio di Vendita Immobiliare",
            "provider": {
              "@type": "RealEstateAgent",
              "name": "Molinaro Immobiliare",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Via Pisana 327",
                "addressLocality": "Scandicci",
                "postalCode": "50018",
                "addressRegion": "FI",
                "addressCountry": "IT"
              }
            },
            "description": "Servizio professionale di vendita immobiliare con valutazione gratuita, strategie di marketing avanzate, e assistenza durante tutto il processo di vendita.",
            "areaServed": "Scandicci",
            "serviceType": "Vendita Immobiliare",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "EUR",
              "name": "Valutazione Immobiliare Gratuita"
            }
          })}
        </script>
      </Helmet>
      <HeroSection />
      <ProcessSection />
      <BenefitsSection />
      <MarketingStrategySection />
      <TestimonialSection />
      <FAQSection />
      <CTASection />
    </div>
  );
};

export default SellWithUs;